import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
type Props = {
  to: string;
  replace?: boolean;
  children?: React.ReactNode;
};

const Link = (props: Props) => {
  const element = props.to.startsWith('/') ? RouterLink : 'a';
  return React.createElement(element, { ...props, href: props.to });
};

export default Link;
